import { Entry } from 'contensis-delivery-api';

import type { Project } from 'Common/hooks/useFilters';
import { getSlugFromContentType } from 'Common/util/ben';

import type { SearchResultCardProps } from 'Components/Card/SearchResult';

import { defaultMap, mediaHubMap } from './maps';

interface Props {
    results: Entry[];
    selectedProject: Project;
}

const domains: { [key: string]: string } = {
    website: 'https://solent.ac.uk',
    warsash: 'https://maritime.solent.ac.uk',
    sportscomplex: 'https://sportscomplex.solent.ac.uk',
    staff: 'https://staff.solent.ac.uk',
    students: 'https://students.solent.ac.uk'
};

const getDomain = (project: Project) => (project !== 'website' ? domains[project] : '');

export const featuredResultsMapping = ({
    results,
    selectedProject
}: Props): SearchResultCardProps[] => {
    const mappingResults: SearchResultCardProps[] = [];

    const domain = getDomain(selectedProject);

    results.map(item => {
        if (['newsArticle', 'event', 'blogArticle'].includes(item.sys.contentTypeId)) {
            mappingResults.push(mediaHubMap(item, 'Featured', domain));
        } else {
            mappingResults.push(defaultMap(item, 'Featured', domain));
        }
    });

    return mappingResults;
};

export const searchResultsMapping = ({
    results,
    selectedProject
}: Props): SearchResultCardProps[] => {
    const mappingResults: SearchResultCardProps[] = [];

    const domain = getDomain(selectedProject);

    results.map(item => {
        switch (item.sys.contentTypeId) {
            // Solent specific
            case 'courseUndergraduate':
            case 'coursePostgraduate':
            case 'courseApprenticeships':
            case 'courseProfessional':
            case 'courseCoaching':
            case 'courseFoundationYears':
                mappingResults.push(defaultMap(item, 'Course', domain));
                break;
            // Sports complex specific
            case 'pageFitnessClasses':
                mappingResults.push(defaultMap(item, 'Fitness classes', domain));
                break;
            case 'pageFitnessClass':
                mappingResults.push(defaultMap(item, 'Fitness class', domain));
                break;
            // Maritime specific
            case 'pageCourseTraining':
            case 'pageCourseAcademic':
                mappingResults.push(defaultMap(item, 'Course', domain));
                break;
            // Documents
            case 'word':
            case 'pdf':
                mappingResults.push({
                    heading: item.title,
                    description: item.description,
                    tag: 'Document',
                    link: {
                        href: `${domain}${item.sys.uri}`
                    }
                });
                break;
            case 'powerPoint':
                mappingResults.push({
                    heading: item.title,
                    description: item.description,
                    tag: 'Document',
                    link: {
                        href: `${domain}/${item.sys.uri}`
                    }
                });
                break;
            // Media hub
            case 'newsArticle':
            case 'event':
            case 'blogArticle':
            case 'videoArticle':
                mappingResults.push(
                    mediaHubMap(item, getSlugFromContentType(item.sys.contentTypeId), domain)
                );
                break;
            // Page default
            default:
                mappingResults.push(defaultMap(item, 'Page', domain));
                break;
        }
    });

    return mappingResults;
};
